export enum ActionTypes {
  GetMarketingCampaignsPlans = 'getMarketingCampaignsPlans',
  GetMarketingCampaignsPlansSuccess = 'getMarketingCampaignsPlans.success',
  GetMarketingCampaignsPlansFailure = 'getMarketingCampaignsPlans.failure',
}
